export default __webpack_public_path__ + "static/media/ic-verify-success.4e7ed56a.svg";